// extracted by mini-css-extract-plugin
export default {"cls1":"SuggestionsCarousel-cls1_gKA","cls2":"SuggestionsCarousel-cls2_kmR SuggestionsCarousel-cls1_gKA"};